import { fetcher } from '@commenda/utils';

import {
  ICreateIndirectTaxCredentialsBulkParams,
  ICreateIndirectTaxCredentialsBulkResponse,
} from './types';

export async function createIndirectTaxCredentialsBulk(
  params: ICreateIndirectTaxCredentialsBulkParams,
  token?: string
): Promise<{
  success: boolean;
  data?: ICreateIndirectTaxCredentialsBulkResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/credentials/bulk',
      { method: 'POST', body: params },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to create credentials',
      };
    }

    const data: ICreateIndirectTaxCredentialsBulkResponse =
      await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to create credentials';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
